
































































































































































































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {CommonStatus} from "@/enums/status";
import {assignValueToForm} from "@/shared/services/helper/utils";
import {CustomerServiceStore} from "@/modules/customerservice/store";
import {FormModel} from "ant-design-vue";
import ProvinceSelector from "@/modules/regions/ProvinceSelector/index.vue";
import DistrictSelector from "@/modules/regions/DistrictSelector/index.vue";
import WardSelector from "@/modules/regions/WardSelector/index.vue";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import {EmployeeType} from "@/enums/type";
import InputCurrency from "@/shared/components/InputCurrency/index.vue";
import {AuthStore} from "@/modules/auth/store";
import moment from "moment";
import AInputCustom from "@/shared/components/CustomInputAnt/index.vue";
import ATextareaCustom from "@/shared/components/TextAreaAntCustom/index.vue";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";

const form = {
    id: "",
    customerName: "",
    address: "",
    taxCode: "",
    infoResource: "",
    countryId: 1,
    provinceId: undefined,
    districtId: undefined,
    // wardId: undefined,
    contactNames: [],
    contactPhones: [],
    contactEmails: [],
    contactName1: "",
    contactPhone1: "",
    contactEmail1: "",
    contactName2: "",
    contactPhone2: "",
    contactEmail2: "",
    contactName3: "",
    contactPhone3: "",
    contactEmail3: "",
    email: "",
    phoneNumber: "",
    competitors: "",
    businessLine: "",
    estimatedRevenue: undefined,
    successRate: undefined,
    quotationDate: undefined,
    lastSupportDate: undefined,
    serviceRequest: "",
    adviseHistoryInput: "",
    adviseHistory: [],
    adviseSchedule: undefined,
    employeeRowGuid: undefined,
    status: undefined
}
@Component({
    name: "CustomerServiceForm",
    components: {
        EnumSelector,
        ATextareaCustom,
        AInputCustom,
        InputCurrency,
        EmployeeSelector, MillisecondDatePicker,
      // WardSelector,
      DistrictSelector, ProvinceSelector}
})
export default class extends mixins(CommonMixin){
    @Prop() readonly id!: number;
    CommonStatus = CommonStatus;
    EmployeeType = EmployeeType;
    form = {...form};
    
    rules = {
        customerName: [{ required: true, message: "Nhập tên đơn vị", trigger: "change" }],
        taxCode: [{ required: false, message: "Nhập mã số thuế", trigger: "change" }],
        address: [{ required: false, message: "Nhập địa chỉ", trigger: "change" }],
        infoResource: [{ required: true, message: "Nhập nguồn lấy thông tin", trigger: "change" }],
        provinceId: [{ required: true, message: "Chọn tỉnh", trigger: "change" }],
        districtId: [{ required: true, message: "Chọn phường xã", trigger: "change" }],
        // wardId: [{ required: true, message: "Chọn phường xã", trigger: "change" }],
        contactName1: [{ required: true, message: "Người liên hệ", trigger: "change" }],
        contactPhone1: [{ required: false, message: "Số điện thoại", trigger: "change" }],
        contactEmail1: [{ required: false, message: "Email", trigger: "change" }],
        contactName2: [{ required: false, message: "Người liên hệ", trigger: "change" }],
        contactPhone2: [{ required: false, message: "Số điện thoại", trigger: "change" }],
        contactEmail2: [{ required: false, message: "Email", trigger: "change" }],
        contactName3: [{ required: false, message: "Người liên hệ", trigger: "change" }],
        contactPhone3: [{ required: false, message: "Số điện thoại", trigger: "change" }],
        contactEmail3: [{ required: false, message: "Email", trigger: "change" }],
        employeeRowGuid: [{ required: true, message: "Nhân viên phụ trách", trigger: "change" }],
        successRate: [{ required: true, message: "Tỉ lệ chốt sales", trigger: "change" }],
        adviseHistoryInput: [{ required: false, message: "Lịch sử tư vấn", trigger: "change" }],
        adviseSchedule: [{ required: true, message: "Lịch hẹn tư vấn", trigger: "change" }]
    }
    
    async created() {
        if (this.id) {
            try {
                const data = await CustomerServiceStore.singleCustomerService(this.id);
                this.paramsToForm(data)
            } catch (e) {
                console.log(e)
                this.$message.error({
                    content: `${e.response?.data?.message || "Đã có lỗi xảy ra"}`
                })
            }
        }
    }

    formToParams() {
        const params = {
            id: this.form.id,
            customerName: this.form.customerName,
            taxCode: this.form.taxCode,
            address: this.form.address,
            infoResource: this.form.infoResource,
            provinceId: this.form.provinceId,
            districtId: this.form.districtId,
            // wardId: this.form.wardId,
            contactNames: '',
            contactPhones: '',
            contactEmails: '',
            successRate: this.form.successRate,
            competitors: this.form.competitors,
            businessLine: this.form.businessLine,
            estimatedRevenue: this.form.estimatedRevenue,
            quotationDate: this.form.quotationDate,
            serviceRequest: this.form.serviceRequest,
            adviseHistory: this.form.adviseHistoryInput,
            adviseSchedule: this.form.adviseSchedule,
            employeeRowGuid: this.form.employeeRowGuid,
            status: this.form.status,
        }

        params.contactNames = JSON.stringify(
        {
            contactName1: this.form.contactName1,
            contactName2: this.form.contactName2,
            contactName3: this.form.contactName3
        })
        params.contactPhones = JSON.stringify(
        {
            contactPhone1: this.form.contactPhone1,
            contactPhone2: this.form.contactPhone2,
            contactPhone3: this.form.contactPhone3
        })
        params.contactEmails = JSON.stringify(
        {
            contactEmail1: this.form.contactEmail1,
            contactEmail2: this.form.contactEmail2,
            contactEmail3: this.form.contactEmail3
        })

        if (this.form.adviseHistoryInput) {
            params.adviseHistory = JSON.stringify(
                [
                    ...this.form.adviseHistory,
                    ...[
                        {
                            name: AuthStore.user.employee?.fullname,
                            time: moment().valueOf(),
                            content: this.form.adviseHistoryInput
                        }
                    ]
                ]
            )
        }

        return params
    }

    paramsToForm(data) {
        this.form = assignValueToForm(this.form, data)
        const contactNames = JSON.parse(data.contactNames)
        const contactPhones = JSON.parse(data.contactPhones)
        const contactEmails = JSON.parse(data.contactEmails)

        this.form.contactName1 = contactNames.contactName1
        this.form.contactName2 = contactNames.contactName2
        this.form.contactName3 = contactNames.contactName3

        this.form.contactPhone1 = contactPhones.contactPhone1
        this.form.contactPhone2 = contactPhones.contactPhone2
        this.form.contactPhone3 = contactPhones.contactPhone3

        this.form.contactEmail1 = contactEmails.contactEmail1
        this.form.contactEmail2 = contactEmails.contactEmail2
        this.form.contactEmail3 = contactEmails.contactEmail3

        this.form.adviseHistory = data.adviseHistory ? JSON.parse(data.adviseHistory) : []
    }
    
    onSubmit() {
        (this.$refs.formCustomerService as FormModel).validate(async (valid) => {
            if (!valid) return;
            try {
                this.id
                    ? await CustomerServiceStore.updateCustomerService(this.formToParams())
                    : await CustomerServiceStore.createCustomerService(this.formToParams());
                this.$notification.success({
                    message: "Thành công",
                    description: `${this.id ? 'Sửa' : 'Tạo'} thành công`
                });
                this.$router.push({name: "customerServiceList"});
            } catch (e) {
                this.$message.error(`${e.response?.data?.message || `${this.id ? 'Sửa' : 'Tạo'} thất bại`}`)
            }
        })
    }

    get canEditAdviseHistory() {
        console.log('vcl', this.id)
        if (!this.id) return true

        console.log(AuthStore.user?.employee?.rowGuid)
        return AuthStore.user?.employee?.rowGuid === this.form.employeeRowGuid
    }
}
